module.exports = __webpack_public_path__ + "img/3.ab96a3a.png";